/** Categorías canónicas — catálogo agosto 2026 (13 secciones). */

export const CATEGORIA_META = {
  Todas: {
    label: 'Todas',
    blurb: 'Catálogo completo para armar el pedido',
    detalle: 'Busca por código o nombre, o elige una categoría abajo para ir más rápido.',
  },
  ASESORIOS: {
    label: 'Accesorios',
    blurb: 'Accesorios y utilidades',
    detalle: 'Accesorios varios para belleza y cuidado personal.',
  },
  'ASESORIOS CABELLO': {
    label: 'Accesorios cabello',
    blurb: 'Accesorios para el cabello',
    detalle: 'Ganchos, pinzas, diademas y accesorios capilares.',
  },
  BARBERIA: {
    label: 'Barbería',
    blurb: 'Barbería y cuidado masculino',
    detalle: 'Productos de barbería y cuidado masculino.',
  },
  'BRILLOS Y SOMBRAS': {
    label: 'Brillos y sombras',
    blurb: 'Brillos, sombras e iluminadores',
    detalle: 'Sombras, brillos, iluminadores y productos para ojos.',
  },
  'BROCHAS Y PINCELES': {
    label: 'Brochas y pinceles',
    blurb: 'Brochas, pinceles y aplicadores',
    detalle: 'Brochas, pinceles y aplicadores de maquillaje.',
  },
  COSMETIQUERAS: {
    label: 'Cosmetiqueras',
    blurb: 'Cosmetiqueras y organizadores',
    detalle: 'Cosmetiqueras, neceseres y organizadores.',
  },
  ELECTRICOS: {
    label: 'Eléctricos',
    blurb: 'Lámparas, secadores y eléctricos',
    detalle: 'Lámparas UV/LED, secadores, planchas y equipos eléctricos.',
  },
  ESMALTES: {
    label: 'Esmaltes',
    blurb: 'Esmaltes y semipermanentes',
    detalle: 'Esmaltes tradicionales, semipermanentes y gelish.',
  },
  'FACIAL Y CORPORAL': {
    label: 'Facial y corporal',
    blurb: 'Cuidado facial y corporal',
    detalle: 'Cremas, mascarillas, serum y cuidado corporal.',
  },
  'PEINILLAS Y CEPILLOS': {
    label: 'Peinillas y cepillos',
    blurb: 'Peinillas, cepillos y peines',
    detalle: 'Peinillas, cepillos, peines y accesorios de peinado.',
  },
  PESTAÑAS: {
    label: 'Pestañas',
    blurb: 'Pestañas, pinzas y accesorios',
    detalle: 'Pestañas postizas, adhesivos, pinzas y accesorios.',
  },
  'STICKER FACIAL': {
    label: 'Sticker facial',
    blurb: 'Stickers y decoración facial',
    detalle: 'Stickers, joyas faciales y decoración.',
  },
  'UÑAS': {
    label: 'Uñas',
    blurb: 'Uñas, tips, geles y herramientas',
    detalle: 'Tips, geles, acrílicos, limas, decoración y herramientas de uñas.',
  },
  'Manicure y Pedicure': {
    label: 'Uñas',
    blurb: 'Uñas, tips, geles y herramientas',
    detalle: 'Tips, geles, acrílicos, limas, decoración y herramientas de uñas.',
  },
};

/** 13 secciones del catálogo ZIP agosto 2026 — chips en vendedor/tienda. */
export const CATALOGO_AGOSTO_SECCIONES = [
  'ASESORIOS',
  'ASESORIOS CABELLO',
  'BARBERIA',
  'BRILLOS Y SOMBRAS',
  'BROCHAS Y PINCELES',
  'COSMETIQUERAS',
  'ELECTRICOS',
  'ESMALTES',
  'FACIAL Y CORPORAL',
  'PEINILLAS Y CEPILLOS',
  'PESTAÑAS',
  'STICKER FACIAL',
  'UÑAS',
];

function catalogoAgostoNombre(nombre) {
  const n = String(nombre || '')
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (n === 'ACCESORIOS') return 'ASESORIOS';
  if (n === 'ACCESORIOS CABELLO') return 'ASESORIOS CABELLO';
  return n;
}

export function isCatalogoAgostoChips(data = []) {
  return (data || []).some((c) => {
    const n = catalogoAgostoNombre(c?.nombre);
    return (
      n &&
      CATALOGO_AGOSTO_SECCIONES.some((s) => catalogoAgostoNombre(s) === n)
    );
  });
}

function enrichChip(c) {
  const nombre = String(c?.nombre || '').trim();
  const key =
    CATALOGO_AGOSTO_SECCIONES.find((s) => catalogoAgostoNombre(s) === catalogoAgostoNombre(nombre)) ||
    nombre;
  return {
    ...c,
    nombre: key,
    label: c.label || categoriaLabel(key),
    blurb: c.blurb || categoriaBlurb(key),
    detalle: c.detalle || c.descripcion || categoriaDetalle(key),
  };
}

/** Solo las 13 secciones del catálogo — nunca chips viejos (Cabello, Maquillaje…). */
export function filterSoloCatalogoAgosto(list = []) {
  const byName = new Map();
  for (const c of list || []) {
    if (!c || c.nombre === 'Todas') continue;
    const key = catalogoAgostoNombre(c.nombre);
    const canon = CATALOGO_AGOSTO_SECCIONES.find((s) => catalogoAgostoNombre(s) === key);
    if (!canon) continue;
    const prev = byName.get(canon);
    if (!prev) byName.set(canon, enrichChip({ ...c, nombre: canon }));
    else
      byName.set(
        canon,
        enrichChip({
          ...prev,
          total: (Number(prev.total) || 0) + (Number(c.total) || 0),
          id: prev.id || c.id,
        })
      );
  }
  return CATALOGO_AGOSTO_SECCIONES.map((nombre, i) => {
    const hit = byName.get(nombre);
    return (
      hit ||
      enrichChip({
        id: nombre,
        nombre,
        total: 0,
        orden: (i + 1) * 10,
      })
    );
  });
}

export function buildCatalogoAgostoChips(list = []) {
  const rest = filterSoloCatalogoAgosto(list);
  const sum = rest.reduce((s, c) => s + (Number(c.total) || 0), 0);
  return [
    enrichChip({
      id: 'todas',
      nombre: 'Todas',
      total: sum,
    }),
    ...rest,
  ];
}

/** Nombre canónico para filtrar en API. */
export function canonicalCategoriaNombre(nombre) {
  const n = String(nombre || '').trim();
  if (!n) return '';
  const key = catalogoAgostoNombre(n);
  const hit = CATALOGO_AGOSTO_SECCIONES.find((s) => catalogoAgostoNombre(s) === key);
  if (hit) return hit;
  if (n === 'Capilar') return 'Cabello';
  if (n === 'Manicure y Pedicure') return 'UÑAS';
  return n;
}

export function categoriaLabel(nombre) {
  const key = canonicalCategoriaNombre(nombre) || nombre;
  return CATEGORIA_META[key]?.label || CATEGORIA_META[nombre]?.label || nombre || '';
}

export function categoriaBlurb(nombre) {
  const key = canonicalCategoriaNombre(nombre) || nombre;
  return CATEGORIA_META[key]?.blurb || CATEGORIA_META[nombre]?.blurb || '';
}

export function categoriaDetalle(nombre) {
  const key = canonicalCategoriaNombre(nombre) || nombre;
  return CATEGORIA_META[key]?.detalle || CATEGORIA_META[nombre]?.detalle || '';
}

/** Normaliza /api/categorias → siempre Todas + 13 secciones catálogo agosto. */
export function normalizeCategorias(data = []) {
  const raw = (data || [])
    .filter((c) => c && c.nombre && c.nombre !== 'General' && c.nombre !== 'Otros')
    .map((c) =>
      enrichChip({
        id: c.id,
        nombre: String(c.nombre || '').trim(),
        total: Number(c.total) || 0,
        orden: Number(c.orden) || 100,
        hijas: Array.isArray(c.hijas) ? c.hijas : [],
        label: c.label,
        blurb: c.blurb,
        detalle: c.descripcion || c.detalle,
      })
    );

  const parent = (data || []).find((c) => Array.isArray(c.subcategorias) && c.subcategorias.length);
  const flat =
    parent && !raw.some((c) => c.nombre !== 'Todas' && isCatalogoAgostoChips([c]))
      ? parent.subcategorias
          .filter((c) => c.nombre !== 'Otros')
          .map((c) =>
            enrichChip({
              id: c.id,
              nombre: String(c.nombre || '').trim(),
              total: Number(c.total) || 0,
              orden: Number(c.orden) || 100,
            })
          )
      : raw.filter((c) => c.nombre !== 'Todas');

  const chips = buildCatalogoAgostoChips(flat);
  const apiTodas = (data || []).find((c) => c && c.nombre === 'Todas');
  if (apiTodas && apiTodas.total != null) {
    chips[0].total = Number(apiTodas.total) || chips[0].total;
  }
  return chips;
}

export const FALLBACK_CATEGORIAS = buildCatalogoAgostoChips(
  CATALOGO_AGOSTO_SECCIONES.map((nombre, i) => ({
    id: i + 1,
    nombre,
    total: null,
    orden: (i + 1) * 10,
  }))
);
